// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
app-root .space-recs-header {
  width: 100%;
  max-width: 695px;
  margin: 0 auto 32px;
}
app-root .space-recs-header h2 {
  font-size: 32px;
  text-align: left;
}
app-root .space-recs {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 695px;
  margin: 0 auto 32px;
}
app-root .space-recs .space-recs-card {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid #af231c;
  background: #fff;
  margin: 0 auto;
}
app-root .space-recs .space-recs-image-carousel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 248px;
}
app-root .space-recs .space-recs-image-carousel img {
  position: absolute;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
app-root .space-recs .space-recs-image-carousel .space-recs-image-carousel-nav {
  z-index: 10;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
app-root .space-recs .space-recs-image-carousel .space-recs-image-carousel-nav button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
  border: none;
  outline: none;
  height: 36;
  width: 24;
  cursor: pointer;
}
app-root .space-recs .space-recs-card-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  padding: 16px;
}
app-root .space-recs .space-recs-card-content h3 {
  font-size: 16px;
  margin: 0;
  text-align: left;
}
app-root .space-recs .space-recs-card-content p {
  text-align: left;
}
app-root .space-recs .space-recs-card-content .space-recs-card-tags {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
}
app-root .space-recs .space-recs-card-content .space-recs-card-tag {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid #595959;
  font-weight: 500;
}
app-root .space-recs .space-recs-card-content .space-recs-card-tag-recommended {
  border-color: #af231c;
  background-color: #af231c;
  color: #fff;
}
app-root .space-recs .space-recs-card-content .space-recs-card-details {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
}
app-root .space-recs .space-recs-card-content .space-recs-card-clamp {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
app-root .space-recs .space-recs-card-content .space-recs-card-text-md {
  font-size: 14px;
}
app-root .space-recs .space-recs-card-content .space-recs-card-text-sm {
  font-size: 12px;
}
app-root .space-recs .space-recs-card-content .space-recs-icon {
  vertical-align: text-bottom;
}
app-root .space-recs .space-recs-card-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
@media (min-width: 600px) {
  app-root .space-recs .space-recs-card-actions {
    flex-direction: row;
    gap: 24px;
  }
}
app-root .space-recs .space-recs-card-actions .hb-button {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}
app-root .space-recs .space-recs-card-actions .space-recs-card-rejected {
  background-color: #000;
  color: #fff;
}
app-root .recs-nav {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  margin-bottom: 0;
  padding: 16px;
  font-size: 1rem;
  background-color: white;
  border-top: 1px solid var(--header-border);
  z-index: 10;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/utilities.less","webpack://./src/Views/Success/LeadFeed/LeadFeedSuccess.less"],"names":[],"mappings":"AA6BA;EAnBE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;ACRF;AAHA;EAEI,WAAA;EACA,gBAAA;EACA,mBAAA;AAIJ;AARA;EAOM,eAAA;EACA,gBAAA;AAIN;AAZA;EAaI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;AApBA;EAqBM,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;AAEN;AA9BA;EAgCM,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AACN;AAtCA;EAwCQ,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AACR;AA5CA;EA+CQ,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAAR;AAnDA;EAsDU,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AAAV;AA/DA;EAwEM,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AANN;AAvEA;EAgFQ,eAAA;EACA,SAAA;EACA,gBAAA;AANR;AA5EA;EAsFQ,gBAAA;AAPR;AA/EA;EA0FQ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,QAAA;AARR;AAtFA;EAkGQ,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AATR;AA7FA;EA0GQ,qBAAA;EACA,yBAAA;EACA,WAAA;AAVR;AAlGA;EAgHQ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAXR;AAxGA;EAuHQ,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;AAZR;AA9GA;EA8HQ,eAAA;AAbR;AAjHA;EAkIQ,eAAA;AAdR;AApHA;EAsIQ,2BAAA;AAfR;AAvHA;EA2IM,aAAA;EACA,sBAAA;EACA,QAAA;AAjBN;AAmBM;EAAA;IACE,mBAAA;IACA,SAAA;EAhBN;AACF;AAlIA;EAqJQ,oBAAA;EACA,mBAAA;EACA,YAAA;AAhBR;AAvIA;EA2JQ,sBAAA;EACA,WAAA;AAjBR;AA3IA;EAkKI,eAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,0CAAA;EACA,WAAA;AApBJ","sourcesContent":["@import './mediaQueries.less';\n@import './GridLayout/layoutHelpers.less';\n\n@pseudo-header-height: 64px;\n@progress-bar-height: 0.25rem;\n@body-gutter-width: 16px;\n@nav-height: calc(1.5rem + 47px);\n\n// styles for screen-reader only content\n.visually-hidden-content() {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.unset-visually-hidden-content() {\n  clip: unset;\n  clip-path: unset;\n  height: unset;\n  overflow: unset;\n  position: unset;\n  white-space: unset;\n  width: unset;\n}\n\n.visually-hidden {\n  .visually-hidden-content();\n}\n\n.fixed-full-width-content() {\n  margin: 0 -16px;\n  left: 16px;\n  width: 100%;\n  min-width: 320px;\n  position: fixed;\n}\n\n.wide-content() {\n  .main-content-width-rules(6);\n}\n.narrow-content() {\n  .main-content-width-rules(4);\n}\n\n// LF Overrides - the 'wide' content covers 2/3 of full width on large screens\n\n.wide-leadfeed-content() {\n  .wide-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8);\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(8, 10);\n  }\n  @media @largeDesktopUp {\n    .calc-column-width(6, 10);\n  }\n}\n.narrow-leadfeed-content() {\n  .narrow-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8) // same as wide content;\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(4, 10);\n  }\n}\n\n.fixed-two-third-width-content() {\n  .fixed-full-width-content();\n  @media @desktopUp {\n    width: 66%;\n  }\n}\n\n// For use within a 'wide' content container\n.nested-input() {\n  .nested-input-width-rules(6);\n}\n\n// For use within a 'wide' content container\n.nested-lf-input() {\n  .nested-input-width-rules(6,8);\n}\n\n// For delaying repeated animation on a list or group of matching elements\n.sequential-delay(@counter, @delay, @child-selector: ~'', @base-delay: 0) when (@counter > 0) {\n  .sequential-delay((@counter - 1), @delay, @child-selector, @base-delay); // next iteration\n\n  &:nth-of-type(@{counter})@{child-selector} {\n    animation-delay: (@base-delay + @delay * (@counter - 1)); // code for each iteration\n  }\n}\n","@import '../../../Styles/utilities.less';\n@import '../../../Styles/colours.less';\n\n@xsmall: ~'(max-width: 374px)';\n\napp-root {\n  .space-recs-header {\n    width: 100%;\n    max-width: 695px;\n    margin: 0 auto 32px;\n\n    h2 {\n      font-size: 32px;\n      text-align: left;\n    }\n  }\n\n  .space-recs {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n    max-width: 695px;\n    margin: 0 auto 32px;\n\n    .space-recs-card {\n      display: flex;\n      flex-direction: row;\n      width: 100%;\n      gap: 16px;\n      border-radius: 8px;\n      border: 1px solid @primary;\n      background: #fff;\n      margin: 0 auto;\n    }\n\n    .space-recs-image-carousel {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n      width: 248px;\n\n      img {\n        position: absolute;\n        height: 100%;\n        width: 100%;\n        object-fit: cover;\n      }\n\n      .space-recs-image-carousel-nav {\n        z-index: 10;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        width: 100%;\n\n        button {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          justify-content: center;\n          background-color: rgba(255, 255, 255, 0.7);\n          border: none;\n          outline: none;\n          height: 36;\n          width: 24;\n          cursor: pointer;\n        }\n      }\n\n      // space-recs-image-carousel-nav-prev\n      // space-recs-image-carousel-nav-next\n    }\n\n    .space-recs-card-content {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 16px;\n      width: 100%;\n      padding: 16px;\n\n      h3 {\n        font-size: 16px;\n        margin: 0;\n        text-align: left;\n      }\n\n      p {\n        text-align: left;\n      }\n\n      .space-recs-card-tags {\n        display: flex;\n        flex-direction: row;\n        align-items: flex-start;\n        flex-wrap: wrap;\n        gap: 8px;\n      }\n\n      .space-recs-card-tag {\n        font-size: 12px;\n        padding: 2px 8px;\n        border-radius: 12px;\n        border: 1px solid @border-grey;\n        font-weight: 500;\n      }\n\n      .space-recs-card-tag-recommended {\n        border-color: @primary;\n        background-color: @primary;\n        color: #fff;\n      }\n\n      .space-recs-card-details {\n        display: flex;\n        flex-direction: row;\n        align-items: flex-start;\n        gap: 16px;\n      }\n\n      .space-recs-card-clamp {\n        overflow: hidden;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n      }\n\n      .space-recs-card-text-md {\n        font-size: 14px;\n      }\n\n      .space-recs-card-text-sm {\n        font-size: 12px;\n      }\n\n      .space-recs-icon {\n        vertical-align: text-bottom;\n      }\n    }\n\n    .space-recs-card-actions {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n\n      @media @portraitTabletUp {\n        flex-direction: row;\n        gap: 24px;\n      }\n\n      .hb-button {\n        display: inline-flex;\n        align-items: center;\n        gap: 0.25rem;\n      }\n\n      .space-recs-card-rejected {\n        background-color: #000;\n        color: #fff;\n      }\n    }\n  }\n\n  .recs-nav {\n    position: fixed;\n    width: 100%;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin-bottom: 0;\n    padding: @body-gutter-width;\n    font-size: 1rem;\n    background-color: white;\n    border-top: 1px solid var(--header-border);\n    z-index: 10;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
